export const s = {
  lightText: { fontWeight: 500, fontSize: '14px', color: '#595959' },
  midText: { fontWeight: 500, fontSize: '14px', color: '#262626' },
  labelText: { fontWeight: 600, fontSize: '16px', color: '#262626' },
  costLabels: { fontWeight: 500, fontSize: '16px', color: '#262626' },
  totalLabel: { fontWeight: 600, fontSize: '18px', color: '#262626' },
  msgText: { color: '#262626' },
  spacedRow: {
    marginBottom: '24px',
  },
  detail: {
    fontWeight: 600,
    fontSize: '16px',
    color: '#383838',
    lineHeight: '24px',
  },
}
